import React from 'react';
import messages from './Messages';
import Reminder from 'components/Reminder';
import ActionLink from 'components/ActionLink';
import Icon from 'components/Icon';
import { IReminderInfo, ITask } from 'store/tasks/tasksType';
import i18n, { languageDirection } from '../../../i18n';
import { Mention, MentionsInput } from 'react-mentions';
import { border1 } from 'utils/style/colors';

interface IComponentProps {
  reminderIndex: number;
  reminder: IReminderInfo;
  dueDateTitle?: string;
  assigneeTitle?: string;
  verifierTitle?: string;
  followersTitle?: string;
  template?: ITask;
  removeReminder: (reminderIndex: number) => void;
  onReminderChange: (
    reminderIndex: number,
    inputType: 'reminder' | 'target' | 'timeTarget' | 'message',
    value: string
  ) => void;
}

class TaskReminder extends React.PureComponent<IComponentProps> {
  notificationsPatternData = [
    {
      id: 'U',
      display: i18n.t('userApplyingChange', { ns: 'companyManagement' }),
    },
    { id: 'AT', display: i18n.t('assigneeTitle', { ns: 'companyManagement' }) },
    {
      id: 'AL',
      display: `${i18n.t('numberOf', { ns: 'companyManagement' })} ${this.props.template?.assigneeTitle || i18n.t('assignee', { ns: 'companyManagement' })}`,
    },
    { id: 'VT', display: i18n.t('verifierTitle', { ns: 'companyManagement' }) },
    {
      id: 'A',
      display: `${this.props.template?.assigneeTitle || i18n.t('assignee', { ns: 'companyManagement' })}`,
    },
    {
      id: 'V',
      display: `${this.props.template?.verifierTitle || (i18n.t('verifier', { ns: 'companyManagement' }) as string)}`,
    },
    {
      id: 'TP',
      display: `${this.props.template?.taskPublisherTitle || (i18n.t('publisher', { ns: 'companyManagement' }) as string)}`,
    },
    {
      id: 'STP',
      display: `${this.props.template?.subTaskPublisherTitle || (i18n.t('subtaskPublisher', { ns: 'companyManagement' }) as string)}`,
    },
    { id: 'TN', display: i18n.t('taskType', { ns: 'companyManagement' }) },
    {
      id: 'P',
      display: i18n.t('progressAmount', { ns: 'companyManagement' }),
    },
    {
      id: 'S',
      display: i18n.t('executionStatus', { ns: 'companyManagement' }),
    },
    {
      id: 'PD',
      display: i18n.t('progressExplanation', { ns: 'companyManagement' }),
    },
    {
      id: 'sdh',
      display: `${this.props.template?.startDateTitle || (i18n.t('startDate', { ns: 'companyManagement' }) as string)} ${i18n.t('withHour', { ns: 'companyManagement' })}`,
    },
    {
      id: 'sd',
      display: `${this.props.template?.startDateTitle || (i18n.t('startDate', { ns: 'companyManagement' }) as string)} ${i18n.t('withoutHour', { ns: 'companyManagement' })}`,
    },
    {
      id: 'ddh',
      display: `${this.props.template?.dueDateTitle || (i18n.t('dueDate', { ns: 'companyManagement' }) as string)} ${i18n.t('withHour', { ns: 'companyManagement' })}`,
    },
    {
      id: 'dd',
      display: `${this.props.template?.dueDateTitle || (i18n.t('dueDate', { ns: 'companyManagement' }) as string)} ${i18n.t('withoutHour', { ns: 'companyManagement' })}`,
    },
    {
      id: 'PN',
      display: `${i18n.t('parentTaskName', { ns: 'companyManagement' }) as string}`,
    },
    {
      id: 'P2N',
      display: `${i18n.t('AncestorTaskName', { ns: 'companyManagement' }) as string}`,
    },
  ];

  handleChangeSelect = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const name = e.target.name;
    const value = e.target.value;
    this.props.onReminderChange(
      this.props.reminderIndex,
      name as 'target' | 'timeTarget',
      value
    );
  };

  displayTransform = (
    notificationList: Array<{ id: string; display: string }>,
    id: string
  ) => {
    return (
      '(' + (notificationList.find((it) => it.id === id)?.display || id) + ')'
    );
  };

  render() {
    const {
      reminderIndex,
      reminder,
      dueDateTitle,
      assigneeTitle,
      verifierTitle,
      followersTitle,
      removeReminder,
      onReminderChange,
    } = this.props;

    const notificationList = [
      ...this.notificationsPatternData,
      ...(this.props.template?.fields?.map((el) => ({
        id: `field:${el.name}`,
        display: `${el?.title}`,
      })) || []),
    ];

    return (
      <div className="container">
        <div
          className="row"
          style={{
            borderBottom: border1,
            padding: '1.2em 0',
            minHeight: '13rem',
          }}
        >
          <div className="col s1" style={{ paddingTop: '28px' }}>
            <ActionLink
              color="red"
              onClick={() => removeReminder(reminderIndex)}
            >
              <Icon type={'x'} />
            </ActionLink>
          </div>
          <div className="col s11">
            <div className="col s4">
              <Reminder
                reminderIndex={reminderIndex}
                onReminderChange={onReminderChange}
                reminderValue={reminder.offsetM.toString()}
              />
            </div>
            <div className="col s4">
              <label htmlFor="target">
                {i18n.t('for', { ns: 'taskManager' }) as string}
              </label>
              <select
                id="target"
                name="target"
                className="browser-default"
                value={reminder.target}
                onChange={this.handleChangeSelect}
              >
                <option value="verifier">
                  {messages.verifier(verifierTitle)}
                </option>
                <option value="assignee">
                  {messages.assignee(assigneeTitle)}
                </option>
                <option value="follower">
                  {messages.followers(followersTitle)}
                </option>
              </select>
            </div>
            <div className="col s4">
              <label htmlFor="timeTarget">
                {i18n.t('basedOn', { ns: 'taskManager' }) as string}
              </label>
              <select
                id="timeTarget"
                name="timeTarget"
                className="browser-default"
                value={reminder.timeTarget}
                onChange={this.handleChangeSelect}
              >
                <option value="dueDate">
                  {dueDateTitle
                    ? dueDateTitle
                    : (i18n.t('dueDate', { ns: 'taskManager' }) as string)}
                </option>
                <option value="startDate">
                  {i18n.t('startDate', { ns: 'taskManager' }) as string}
                </option>
                <option value="verifyDate">
                  {i18n.t('verifyDate', { ns: 'taskManager' }) as string}
                </option>
              </select>
            </div>

            <div className="col s12">
              <MentionsInput
                value={reminder.message || undefined}
                onChange={(e) => {
                  onReminderChange(
                    reminderIndex,
                    'message',
                    e.target.value || ''
                  );
                }}
                forceSuggestionsAboveCursor={false}
                allowSuggestionsAboveCursor={true}
                allowSpaceInQuery={true}
                className={`surveySMSPattern ${languageDirection() === 'rtl' ? 'rtl-mention' : 'ltr-mention'}`}
                placeholder={i18n.t('reminderMessage', {
                  ns: 'companyManagement',
                })}
                style={{ zIndex: 100 }}
              >
                <Mention
                  trigger={'%'}
                  data={notificationList}
                  markup={'%__id__'}
                  displayTransform={(id) =>
                    this.displayTransform(notificationList, id)
                  }
                  regex={/%(\S+)/}
                  appendSpaceOnAdd={true}
                />
                <Mention
                  trigger={'٪'}
                  data={notificationList}
                  markup={'%__id__'}
                  displayTransform={(id) =>
                    this.displayTransform(notificationList, id)
                  }
                  regex={/%(\S+)/}
                  appendSpaceOnAdd={true}
                />
              </MentionsInput>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default TaskReminder;
